/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdAdvertiserProfitUpdateDTO,
  AdPublisherProfitUpdateDTO,
  ResponseApiAdProfitInfoRespListDTO,
  ResponseApiInt,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class LiRunGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags LiRunGuanLi
   * @name UpdateAdvertiserProfitUsingPut
   * @summary 更新广告主利润
   * @request PUT:/dsp-admin/api/profit/advertiser-profit
   * @secure
   */
  updateAdvertiserProfitUsingPut = (
    updateDto: AdAdvertiserProfitUpdateDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiInt, void>({
      path: `/dsp-admin/api/profit/advertiser-profit`,
      method: "PUT",
      body: updateDto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LiRunGuanLi
   * @name GetGlobalProfitInfoUsingGet
   * @summary 获取全局利润信息
   * @request GET:/dsp-admin/api/profit/global-info
   * @secure
   */
  getGlobalProfitInfoUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiAdProfitInfoRespListDTO, void>({
      path: `/dsp-admin/api/profit/global-info`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LiRunGuanLi
   * @name UpdateGlobalPublisherProfitUsingPut
   * @summary 更新媒体全局利润
   * @request PUT:/dsp-admin/api/profit/publisher-profit
   * @secure
   */
  updateGlobalPublisherProfitUsingPut = (
    updateDto: AdPublisherProfitUpdateDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/profit/publisher-profit`,
      method: "PUT",
      body: updateDto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new LiRunGuanLi();
